import { Flower2 } from "lucide-react";
import { MARQUEE_ITEMS } from "@/lib/site";

const Row = ({ hidden }) => (
  <div
    aria-hidden={hidden}
    className="flex shrink-0 items-center gap-10 pr-10"
  >
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-10">
        <span className="whitespace-nowrap font-serif text-2xl italic text-cream/70 md:text-4xl">
          {item}
        </span>
        <Flower2 className="h-5 w-5 shrink-0 text-magenta/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="services-marquee"
      className="overflow-hidden border-y border-magenta/15 bg-plum-900/50 py-7"
      aria-label="Our signature treatments"
    >
      <div className="flex w-max animate-marquee">
        <Row hidden={false} />
        <Row hidden />
      </div>
    </section>
  );
}
